import React from 'react'
import { useTranslation } from 'react-i18next'
import { useTheme } from 'styled-components'
import { Text, Flex } from '@mprolab/uikit'
import { Check, XCircle } from 'react-feather'
import UseAnimations from 'react-useanimations'
import loading from 'react-useanimations/lib/loading'

interface StatusBarProps {
  isUserVerified: boolean
  isLoading?: boolean
}

const StatusBar: React.FC<StatusBarProps> = ({ isLoading, isUserVerified }) => {
  const theme = useTheme()
  const { t } = useTranslation()

  let content = {
    node: <UseAnimations animation={loading} strokeColor={theme.colors.white3} />,
    title: 'loading',
    titeColor: theme.colors.contrast
  }

  if (!isLoading) {
    content = isUserVerified
      ? {
          node: <Check color={theme.colors.green} />,
          title: 'verified',
          titeColor: theme.colors.green
        }
      : { node: <XCircle color={theme.colors.red} />, title: 'rejected', titeColor: theme.colors.red }
  }

  return (
    <Flex p="8px 16px" background={theme.colors.gray10} borderRadius="58px" alignItems="center">
      {content.node}
      <Text color={content.titeColor} ml="10px">
        {t(`web3Modal.${content.title}`)}
      </Text>
    </Flex>
  )
}

export default StatusBar
